export default "__VITE_ASSET__BdtCOlOJ__"